"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AuthenticationService_1 = require("../Services/AuthenticationService");
var ConnectionService_1 = require("../Services/ConnectionService");
var Components_1 = require("../Components");
var SiteLogo = require("Assets/Images/site_logo.png");
var CompanyLogo = require("Assets/Images/company_logo.png");
var EventModal_1 = require("../Components/EventModal");
var Context_1 = require("../Context");
var reactstrap_1 = require("reactstrap");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var Pages_1 = require("../Pages");
var EventHandlerService_1 = require("../Services/EventHandlerService");
var Endpoints_1 = require("../Utils/Endpoints");
require("./Styles/AuthenticatedApp.css");
var Services_1 = require("../Services");
var Components_2 = require("./Components");
var History_1 = require("../Utils/History");
var Exports_1 = require("../Types/Exports");
var AuthenticatedApp = /** @class */ (function (_super) {
    __extends(AuthenticatedApp, _super);
    function AuthenticatedApp(props) {
        var _this = _super.call(this, props) || this;
        _this.updateAppData = function (key, value) {
            //console.log("AuthenticatedApp updateAppData")
            //console.log(`AuthenticatedApp updateAppData update state: ${key}`)
            //console.log(value)
            _this.setState(function (prevState) {
                var _a;
                return ({
                    applicationData: __assign(__assign({}, prevState.applicationData), (_a = {}, _a[key] = value, _a))
                });
            });
            if (key == AuthenticationService_1.AuthenticationService.selectedLocationKey) {
                sessionStorage.setItem(AuthenticationService_1.AuthenticationService.selectedLocationKey, value);
                ConnectionService_1.SignalRConnection.syncConnection(AuthenticationService_1.Auth.getUser().Organisation, value);
                _this.updateQueueCount(true);
                _this.updateQueueCount(false);
            }
        };
        _this.updateQueueCount = function (isStoreAndForward) {
            //console.log("AuthenticatedApp updateQueueCount")
            if (!isStoreAndForward) {
                Services_1.getJson(Endpoints_1.default.GetMultipleQueueCount, undefined, true, new Services_1.UserRequestHeaders(__assign(__assign({}, AuthenticationService_1.Auth.getUser()), { Location: _this.state.applicationData.selectedLocation || sessionStorage.getItem(AuthenticationService_1.AuthenticationService.selectedLocationKey) })))
                    .then(function (response) {
                    var value = JSON.parse(response);
                    _this.updateAppData("multipleQueueCount", value);
                    //this.setState({ applicationData: { ...this.state.applicationData, multipleQueueCount: value}})
                })
                    .catch(function (reason) {
                    return console.error("Error loading multipleQueueCount. With reason: " + reason);
                });
            }
            else {
                Services_1.getJson(Endpoints_1.default.GetDeferredQueueCount, undefined, true, new Services_1.UserRequestHeaders(__assign(__assign({}, AuthenticationService_1.Auth.getUser()), { Location: _this.state.applicationData.selectedLocation || sessionStorage.getItem(AuthenticationService_1.AuthenticationService.selectedLocationKey) })))
                    .then(function (response) {
                    var value = JSON.parse(response);
                    _this.updateAppData("deferredQueueCount", value);
                    //this.setState({ applicationData: { ...this.state.applicationData, multipleQueueCount: value}})
                })
                    .catch(function (reason) {
                    return console.error("Error loading deferredQueueCount. With reason: " + reason);
                });
            }
        };
        _this.loading = function () {
            //console.log("AuthenticatedApp loading")
            return (React.createElement(Components_1.FullView, { horizontal: true, vertical: true },
                React.createElement(Components_1.Center, { horizontal: true, vertical: true },
                    React.createElement(Components_1.CustomSpinner, null)),
                React.createElement(EventModal_1.EventModal, { backdrop: "static" })));
        };
        _this.authStateUpdated = function (forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = true; }
            //console.log("AuthenticatedApp authStateUpdated")
            if (AuthenticationService_1.Auth.State == AuthenticationService_1.AuthenticationState.Authenticated) {
                //console.log("AuthenticatedApp authStateUpdated SignalRConnection init")
                ConnectionService_1.SignalRConnection.init(AuthenticationService_1.Auth, function (isConnected) {
                    return _this.setState({
                        isConnected: isConnected
                    }, function () {
                        if (isConnected) {
                            ConnectionService_1.SignalRConnection.syncConnection(AuthenticationService_1.Auth.getUser().Organisation, _this.state.applicationData.selectedLocation || sessionStorage.getItem(AuthenticationService_1.AuthenticationService.selectedLocationKey));
                        }
                    });
                }, _this.updateQueueCount, function (newConnectionState) {
                    _this.setState({ applicationData: __assign(__assign({}, _this.state.applicationData), { connectionState: newConnectionState }) });
                }, function (isOnline) {
                    _this.setState({ applicationData: __assign(__assign({}, _this.state.applicationData), { nbsIsConnected: isOnline }) });
                }, _this.state.applicationData.resources);
            }
            if (forceUpdate) {
                _this.forceUpdate();
            }
        };
        //console.log("AuthenticatedApp constructor")
        EventHandlerService_1.EventHandlerProvider.Set(function (eventHandler) {
            _this.setState({
                eventHandler: eventHandler
            });
        });
        _this.state = {
            isConnected: ConnectionService_1.SignalRConnection.isConnected,
            finishedLoading: false,
            applicationData: {
                selectedLocation: sessionStorage.getItem(AuthenticationService_1.AuthenticationService.selectedLocationKey),
                updateCallback: function (key, value) { return _this.updateAppData(key, value); }
            },
            eventHandler: EventHandlerService_1.EventHandlerProvider.GetInstance()
        };
        //console.log("AuthenticatedApp constructor initial state")
        //console.log(this.state)
        Services_1.getJson(Endpoints_1.default.GetResources, undefined, false).then(function (json) {
            var res = JSON.parse(json);
            //console.log("update resources")
            _this.setState({ applicationData: __assign(__assign({}, _this.state.applicationData), { resources: res }) });
            AuthenticationService_1.Auth.init(function (location) { /*console.log(`auth init update location: ${location}`);*/ _this.setState({ applicationData: __assign(__assign({}, _this.state.applicationData), { selectedLocation: location }) }); });
            _this.authStateUpdated(false);
        });
        return _this;
    }
    AuthenticatedApp.prototype.componentDidMount = function () {
        //console.log("AuthenticatedApp componentDidMount")
        var sessionLocation = sessionStorage.getItem(AuthenticationService_1.AuthenticationService.selectedLocationKey);
        if (this.state.applicationData.selectedLocation != sessionLocation) {
            //console.log(`AuthenticatedApp componentDidMount update location ${sessionLocation}`)
            this.setState({ applicationData: __assign(__assign({}, this.state.applicationData), { selectedLocation: sessionLocation }) });
        }
    };
    AuthenticatedApp.prototype.componentDidUpdate = function () {
        //console.log("AuthenticatedApp componentDidUpdate")
        if (this.state.finishedLoading) {
            //console.log("AuthenticatedApp componentDidUpdate not waiting for loading")
            var sessionLocation = sessionStorage.getItem(AuthenticationService_1.AuthenticationService.selectedLocationKey);
            if (sessionLocation == undefined || sessionLocation == "undefined" || sessionLocation == null) {
                //console.log("AuthenticatedApp componentDidUpdate session location is scuffed")
                if (this.state.applicationData.locations.length == 0) {
                    //console.log("AuthenticatedApp componentDidUpdate org has no locations")
                    if (this.props.location.pathname != '/Settings') {
                        //console.log("AuthenticatedApp componentDidUpdate not on settings page")
                        var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                        //console.log("AuthenticatedApp componentDidUpdate get event handler")
                        if (!eventHandler.HasEvent()) {
                            //console.log("AuthenticatedApp componentDidUpdate first time setup event")
                            EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Exports_1.VeriLiteInformationEvent(this.state.applicationData.resources.FirstTimeSetupMessage, this.state.applicationData.resources.FirstTimeSetupTitle, [new Exports_1.VeriLiteEventAction(this.state.applicationData.resources.Ok, "primary", function (currentEvent, closeModal) { History_1.default.push('/Settings'); closeModal(); })]));
                        }
                    }
                }
                else {
                    //console.log("AuthenticatedApp componentDidUpdate has locations, set selected to default")
                    //console.log(Auth.getUser().Location)
                    this.updateAppData(AuthenticationService_1.AuthenticationService.selectedLocationKey, AuthenticationService_1.Auth.getUser().Location);
                }
            }
            else {
                //console.log("AuthenticatedApp componentDidUpdate session location is good")
                if (this.state.applicationData.selectedLocation == undefined || this.state.applicationData.selectedLocation == "undefined" || this.state.applicationData.selectedLocation == null) {
                    //console.log("AuthenticatedApp componentDidUpdate state location is scuffed, replace with session location")
                    this.setState(function (prevState) { return { applicationData: __assign(__assign({}, prevState.applicationData), { selectedLocation: sessionLocation }) }; });
                }
            }
        }
    };
    AuthenticatedApp.prototype.render = function () {
        var _this = this;
        //console.log("AuthenticatedApp render")
        switch (AuthenticationService_1.Auth.State) {
            case AuthenticationService_1.AuthenticationState.Unauthenticated:
                //console.log("AuthenticatedApp render Unauthenticated")
                return this.loading();
            case AuthenticationService_1.AuthenticationState.Loading:
                //console.log("AuthenticatedApp render Loading")
                return this.loading();
            case AuthenticationService_1.AuthenticationState.Error:
                //console.log("AuthenticatedApp render Error")
                return React.createElement(EventModal_1.EventModal, { backdrop: "static" });
            case AuthenticationService_1.AuthenticationState.Authenticated:
                //console.log("AuthenticatedApp render Authenticated")
                return (React.createElement("div", null,
                    React.createElement(EventModal_1.EventModal, { backdrop: true }),
                    !this.state.finishedLoading ?
                        React.createElement(Components_1.DataLoader, { dataToLoad: [
                                { key: "supportedLanguages", endpoint: Endpoints_1.default.GetSupportedLanguages },
                                { key: "selectedLanguage", endpoint: Endpoints_1.default.GetSelectedLanguage },
                                { key: "userInfo", endpoint: Endpoints_1.default.GetUserInfo },
                                { key: "availableActions", endpoint: Endpoints_1.default.GetAvailableActions },
                                { key: "calibrationData", endpoint: Endpoints_1.default.GetCalibrationData },
                                { key: "locations", endpoint: Endpoints_1.default.GetLocations },
                                { key: "apiProvider", endpoint: Endpoints_1.default.GetApiProvider },
                                { key: "multipleQueueCount", endpoint: Endpoints_1.default.GetMultipleQueueCount },
                                { key: "deferredQueueCount", endpoint: Endpoints_1.default.GetDeferredQueueCount },
                                { key: "version", endpoint: Endpoints_1.default.GetVersion },
                                { key: "mvpLink", endpoint: Endpoints_1.default.GetMvpLink },
                                { key: "showHelpLink", endpoint: Endpoints_1.default.GetShowHelpLink }
                            ], onComplete: function () { /*console.log("AuthenticatedApp render loading complete");*/ _this.setState({ finishedLoading: true }); }, onUpdate: function (key, value) {
                                //console.log(`AuthenticatedApp render loading update state ${key}`)
                                //console.log(value)
                                _this.setState(function (prevState) {
                                    var _a;
                                    return ({
                                        applicationData: __assign(__assign({}, prevState.applicationData), (_a = {}, _a[key] = value, _a))
                                    });
                                });
                            }, siteLogo: SiteLogo, isConnected: this.state.isConnected, location: this.state.applicationData.selectedLocation, resources: this.state.applicationData.resources })
                        :
                            React.createElement(Context_1.GlobalProvider, { value: this.state.applicationData },
                                React.createElement(Context_1.AuthProvider, { value: AuthenticationService_1.Auth },
                                    React.createElement(reactstrap_1.Fade, { timeout: 300 },
                                        React.createElement(Components_1.Layout, { siteLogo: SiteLogo, companyLogo: CompanyLogo },
                                            React.createElement(react_router_dom_1.Switch, null,
                                                React.createElement(react_router_1.Route, { exact: true, path: '/Dashboard/:path?/:path2?', render: function (props) {
                                                        return React.createElement(Pages_1.Dashboard, __assign({}, props, { resources: _this.state.applicationData.resources, siteLogo: SiteLogo, companyLogo: CompanyLogo, supportedLanguages: _this.state.applicationData.supportedLanguages }));
                                                    } }),
                                                React.createElement(react_router_1.Route, { exact: true, path: '/CalibrateScanner', render: function (props) { return React.createElement(Pages_1.CalibrateScanner, __assign({}, props, { applicationData: _this.state.applicationData })); } }),
                                                React.createElement(react_router_1.Route, { exact: true, path: '/Settings/:path?', render: function (props) { return React.createElement(Pages_1.Settings, __assign({}, props, { resources: _this.state.applicationData.resources })); } }),
                                                React.createElement(react_router_1.Route, { exact: true, path: '/EchoPage', render: function (props) { return React.createElement(Pages_1.Echo, null); } }),
                                                React.createElement(react_router_1.Route, { render: function () { return React.createElement(Components_1.SafeRedirect, { to: "/Dashboard/Safe", resources: _this.state.applicationData.resources }); } }))))))));
            case AuthenticationService_1.AuthenticationState.PasswordReset:
                //console.log("AuthenticatedApp render PasswordReset")
                return React.createElement(Components_2.PasswordResetLanding, { resources: this.state.applicationData.resources });
            case AuthenticationService_1.AuthenticationState.TwoFactor:
                //console.log("AuthenticatedApp render TwoFactor")
                return React.createElement(Components_2.TwoFactorAuthentication, { forceAppUpdate: this.authStateUpdated, siteLogo: SiteLogo, companyLogo: CompanyLogo, resources: this.state.applicationData.resources });
            case AuthenticationService_1.AuthenticationState.LicenseError:
                //console.log("AuthenticatedApp render LicenseError")
                return React.createElement(Pages_1.LicenseError, { resources: this.state.applicationData.resources });
        }
    };
    return AuthenticatedApp;
}(React.Component));
exports.AuthenticatedApp = AuthenticatedApp;
//# sourceMappingURL=AuthenticatedApp.js.map